export const fmtCompact = (n: number, digits = 2): string => {
    if (!Number.isFinite(n)) return "—";
    if (n >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(digits)}B`;
    if (n >= 1_000_000)     return `${(n / 1_000_000).toFixed(digits)}M`;
    if (n >= 1_000)         return `${(n / 1_000).toFixed(digits)}K`;
    return n.toFixed(digits);
};

export const fmtPct = (bps: number, digits = 1): string => {
    return `${(bps / 100).toFixed(digits)}%`;
};

export const fmtAddress = (addr?: string): string => {
    if (!addr || addr.length < 10) return "—";
    return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
};

export const fmtEth = (n: number, digits = 4): string => {
    if (!Number.isFinite(n)) return "—";
    return `${n.toFixed(digits)} ETH`;
};

export const fmtTokens = (n: number, digits = 2): string => {
    return `${fmtCompact(n, digits)} PIGGY`;
};
